<template>
  <div class="mf-card benefit-coupons-table-container">
    <span class="title">Resultado por tipo de voucher</span>
    <v-data-table :headers="headers" :items="items">
      <template v-slot:item.coupon_img="{ item }">
        <div class="img-container">
          <img :src="item.coupon_img" />
        </div>
      </template>

      <template v-slot:item.name="{ item }">
        <span>
          Voucher <strong>R${{ item.name }}</strong> - Zé Delivery
        </span>
      </template>

      <template v-slot:item.revenue="{ item }">
        <span>{{ localeString(item.revenue, 2) | currency }}</span>
      </template>

      <template v-slot:item.ticket="{ item }">
        <span>{{ localeString(item.ticket, 2) | currency }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'BenefitCouponsTable',
  props: {
    metrics: {
      type: Object,
      default: () => ({}),
    },
    coupons: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        {
          text: '',
          value: 'coupon_img',
          width: '5%',
          sortable: false,
        },
        {
          text: '',
          value: 'name',
          width: '30%',
          sortable: false,
        },
        {
          text: 'Faturamento',
          align: 'left',
          value: 'revenue',
        },
        {
          text: 'Clientes',
          align: 'left',
          value: 'clients',
        },
        {
          text: 'Cupons',
          align: 'left',
          value: 'coupons',
        },
        {
          text: 'Ticket médio',
          align: 'left',
          value: 'ticket',
        },
      ]
    },
    items() {
      return this.coupons.map((coupon) => {
        const couponMetrics = this.metrics?.benefits_metrics_table_consumed?.table?.find((item) => item._id === coupon.code)?.consumed
        return {
          coupon_img: coupon.image,
          name: coupon.discount || 0,
          revenue: couponMetrics?.revenue || 0,
          clients: couponMetrics?.clients || 0,
          coupons: couponMetrics?.tickets || 0,
          ticket: couponMetrics?.tickets === 0 ? 0 : couponMetrics?.revenue / couponMetrics?.tickets || 0,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.benefit-coupons-table-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .title {
    font-size: 20px;
    font-weight: bold;
    color: $cinza-d10;
  }

  .img-container {
    margin: 6px 0;
    border: 1px dashed #c4baf7;
    border-radius: 4px;
    width: 50px;

    & img {
      display: block;
      width: 48px;
      height: 48px;
      object-fit: contain;
    }
  }
}
</style>
